export default "/kiban/_next/static/images/green-f075c89051f3b5146e4222c0d1a7a46c.png";